import { IGetAtributosSistemaUseCase } from "../../../presentation/useCases/read/get_atributos_sistema_use_case";
import { AtributoSistemaModel } from "../../models/atributos_sistema";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetAtributosSistemaUseCase
 */

export class GetAtributosSistemaUseCase implements IGetAtributosSistemaUseCase {
  constructor(private readonly repository: IAdministracaoRepository) { }

  async execute(): Promise<AtributoSistemaModel> {
    const result = await this.repository.getAtributoSistema();
    return result;

  }
}
